import { render, staticRenderFns } from "./StudentPage.vue?vue&type=template&id=609ebe22&"
import script from "./StudentPage.vue?vue&type=script&lang=js&"
export * from "./StudentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports